import { PropertyType } from "../../../types";
import { members } from "./branchData";
import { utilities } from "./utilitiesIcons";
// export const mockProperties: PropertyType[] = [
//     {
//         id: 1,
//         images: [
//             "https://source.unsplash.com/600x400/?apartment",
//             "https://source.unsplash.com/600x400/?livingroom",
//         ],
//         title: "Luxury 2-Bedroom Apartment in Downtown",
//         address: "123 Main Street, Cityville, NY",
//         category: "residential",
//         size: "1200 sqm",
//         price: 2500,
//         priceType: "totalPackage",
//         quote: "monthly",
//         quotePrice: 2500,
//         type: "rent",
//         reviews: ["Great location!", "Spacious and modern."],
//         serviceCharge: 200,
//         inspectionFee: 50,
//         refundableCautionFee: 500,
//         nonRefundabeLegalFees: 300,
//         otherFee: 150,
//         propertyBrief: [
//             "Modern design with open floor plan",
//             "Close to shopping centers",
//             "Secure building with 24/7 security",
//         ],
//         bathroom: 2,
//         bedroom: 2,
//         toilet: 2,
//         totalViews: 1200,
//         bookMarks: 300,
//         addedDate: "2025-02-15",
//         lastUpdated: "2025-02-20",
//         availableUnits: 5,
//         utilities: ["Water", "Electricity", "WiFi"],
//     },
//     {
//         id: 2,
//         images: [
//             "https://source.unsplash.com/600x400/?villa",
//             "https://source.unsplash.com/600x400/?pool",
//         ],
//         title: "Spacious 4-Bedroom Villa with Pool",
//         address: "456 Sunset Blvd, Los Angeles, CA",
//         category: "residential",
//         size: "3500 sqm",
//         price: 6000,
//         priceType: "totalPackage",
//         quote: "monthly",
//         quotePrice: 6000,
//         type: "rent",
//         reviews: ["Perfect for families!", "Amazing pool and garden."],
//         serviceCharge: 400,
//         refundableCautionFee: 1200,
//         nonRefundabeLegalFees: 500,
//         otherFee: 250,
//         propertyBrief: [
//             "Private swimming pool",
//             "Spacious backyard",
//             "Gated community with security",
//         ],
//         bathroom: 4,
//         bedroom: 4,
//         toilet: 5,
//         totalViews: 900,
//         bookMarks: 150,
//         addedDate: "2025-01-30",
//         lastUpdated: "2025-02-18",
//         availableUnits: 2,
//         utilities: ["Water", "Electricity", "WiFi", "Security"],
//     },
//     {
//         id: 3,
//         images: [
//             "https://source.unsplash.com/600x400/?office",
//             "https://source.unsplash.com/600x400/?workspace",
//         ],
//         title: "Modern Office Space in Business District",
//         address: "789 Corporate Plaza, Chicago, IL",
//         category: "commercial",
//         size: "2500 sqm",
//         price: 8000,
//         priceType: "totalPackage",
//         quote: "monthly",
//         quotePrice: 8000,
//         type: "rent",
//         reviews: ["Great location for startups!", "Spacious and well-lit."],
//         serviceCharge: 600,
//         inspectionFee: 100,
//         refundableCautionFee: 2000,
//         nonRefundabeLegalFees: 1000,
//         otherFee: 300,
//         propertyBrief: [
//             "Fully furnished office space",
//             "Close to public transport",
//             "High-speed internet included",
//         ],
//         bathroom: 2,
//         totalViews: 500,
//         bookMarks: 80,
//         addedDate: "2025-02-01",
//         lastUpdated: "2025-02-21",
//         availableUnits: 3,
//         utilities: ["Electricity", "Internet", "Water", "Security"],
//     },
//     {
//         id: 4,
//         images: [
//             "https://source.unsplash.com/600x400/?loft",
//             "https://source.unsplash.com/600x400/?rooftop",
//         ],
//         title: "Chic Studio Loft in Arts District",
//         address: "321 Creative Ave, Austin, TX",
//         category: "residential",
//         size: "750 sqm",
//         price: 1800,
//         priceType: "totalPackage",
//         quote: "monthly",
//         quotePrice: 1800,
//         type: "rent",
//         reviews: ["Perfect for artists!", "Cozy and stylish."],
//         serviceCharge: 100,
//         refundableCautionFee: 300,
//         nonRefundabeLegalFees: 200,
//         otherFee: 100,
//         propertyBrief: [
//             "Open floor plan with industrial design",
//             "Pet-friendly apartment",
//             "Close to cafes and art galleries",
//         ],
//         bathroom: 1,
//         bedroom: 1,
//         toilet: 1,
//         totalViews: 700,
//         bookMarks: 200,
//         addedDate: "2025-02-10",
//         lastUpdated: "2025-02-22",
//         availableUnits: 4,
//         utilities: ["WiFi", "Water", "Electricity"],
//     },
// ];


export type PropertyTypeKey = "forRent" | "forSale" | "forShortlet";

export interface MockPropertyType {
    forRent: PropertyType[];
    forSale: PropertyType[];
    forShortlet: PropertyType[];
}

export const propertiesData: PropertyType[] = [
    {
        id: 1,
        images: [
            "/images/new-img-4.webp",
            "/images/sample-1.webp", "/images/sample-2.webp",
            "/images/sample-3.webp",
            "/images/sample-4.webp",
            "/images/sample-5.webp",

        ],
        coordinate: [6.4913408, 3.391488],
        title: "Luxury 3-Bedroom Detached Bungalow ",
        currency: "naira",
        address: "123 Main Street, Akoka, Lagos",
        category: "residential",
        size: 950,
        price: 4700000,
        priceType: "totalPackage",
        quote: "annum",
        quotePrice: 3500000,
        type: "rent",
        reviews: ["Great location!", "Spacious and modern."],
        serviceCharge: 200,
        inspectionFee: 50,
        refundableCautionFee: 500,
        nonRefundableLegalFees: 300,
        otherFee: 150,
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        propertyBrief: [
            "Modern design with open floor plan",
            "Close to shopping centers",
            "Secure building with 24/7 security",
        ],
        bathroom: 2,
        bedroom: 2,
        toilet: 2,
        totalViews: 1200,
        bookMarks: 300,
        addedDate: "2025-02-15",
        lastUpdated: "2025-02-20",
        availableUnits: 5,
        utilities: ["Water", "Electricity", "WiFi"],
    },
    {
        id: 2,
        images: [
            "/images/new-img-5.webp",
            "https://source.unsplash.com/600x400/?pool",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        title: "Spacious 4-Bedroom Detached Duplex ",
        address: "456 Sunset Blvd, Maitama, Abuja",
        category: "residential",
        size: 700,
        price: 1200000,
        priceType: "totalPackage",
        quote: "month",
        quotePrice: 950000,
        type: "rent",
        reviews: ["Perfect for families!", "Great location!", "Amazing pool and garden."],
        serviceCharge: 400,
        refundableCautionFee: 1200,
        nonRefundableLegalFees: 300,
        otherFee: 250,
        propertyBrief: [
            "Private swimming pool",
            "Spacious backyard",
            "Gated community with security",
        ],
        bathroom: 4,
        bedroom: 4,
        toilet: 5,
        totalViews: 900,
        bookMarks: 150,
        addedDate: "2025-01-30",
        lastUpdated: "2025-02-18",
        availableUnits: 2,
        utilities: ["Water", "Electricity", "WiFi", "Security"],
    },
    {
        id: 3,
        images: [
            "/images/proxy.webp",
            "https://source.unsplash.com/600x400/?workspace",
        ],
        currency: "naira",
        coordinate: [6.4913408, 3.391488],
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        title: "6 Bedroom Semi-Detached Duplex",
        address: "789 Corporate Plaza, Kolapo Ishola GRA, Ibadan",
        category: "commercial",
        size: 1200,
        price: 700000,
        priceType: "totalPackage",
        quote: "week",
        quotePrice: 500000,
        type: "rent",
        reviews: ["Great location for startups!", "Spacious and well-lit.", "Great location for startups!", "Spacious and well-lit."],
        serviceCharge: 600,
        inspectionFee: 100,
        refundableCautionFee: 2000,
        nonRefundableLegalFees: 300,
        otherFee: 300,
        propertyBrief: [
            "Fully furnished office space",
            "Close to public transport",
            "High-speed internet included",
        ],
        bathroom: 2,
        totalViews: 500,
        bookMarks: 80,
        addedDate: "2025-02-01",
        lastUpdated: "2025-02-21",
        availableUnits: 3,
        utilities: ["Electricity", "Internet", "Water", "Security"],
    },
    {
        id: 4,
        images: [
            "/images/rent-4.webp",
            "https://source.unsplash.com/600x400/?rooftop",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "3 Bedroom Terrace Duplex",
        address: "321 Creative Ave, Trans Amadi, Rivers",
        category: "residential",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 350,
        price: 6370000,
        priceType: "totalPackage",
        quote: "annum",
        quotePrice: 5500000,
        type: "rent",
        reviews: ["Perfect for artists!", "Cozy and stylish.", "Great location for startups!", "Spacious and well-lit.", "Great location for startups!", "Spacious and well-lit."],
        serviceCharge: 100,
        refundableCautionFee: 300,
        nonRefundableLegalFees: 300,
        otherFee: 100,
        propertyBrief: [
            "Open floor plan with industrial design",
            "Pet-friendly apartment",
            "Close to cafes and art galleries",
        ],
        bathroom: 1,
        bedroom: 1,
        toilet: 1,
        totalViews: 700,
        bookMarks: 200,
        addedDate: "2025-02-10",
        lastUpdated: "2025-02-22",
        availableUnits: 4,
        utilities: ["WiFi", "Water", "Electricity"],
    },
    {
        id: 5,
        images: [
            "/images/new-img-2.webp",
            "https://source.unsplash.com/600x400/?backyard",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "Luxury 5-Bedroom Duplex With 2-Bedroom BQ",
        address: "456 Beverly Hills, Apete, Ibadan",
        category: "residential",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        beforePrice: 2000000,
        discount: "30%",
        size: 600,
        price: 55000000,
        priceType: "askingPrice",
        quote: "firstDeposit",
        quotePrice: 2750000,
        type: "sale",
        reviews: ["State-of-the-art home automation!", "Excellent location."],
        serviceCharge: 500,
        inspectionFee: 200,
        refundableCautionFee: 5000,
        nonRefundableLegalFees: 300,
        otherFee: 1000,
        propertyBrief: [
            "Integrated smart home technology",
            "Expansive backyard with pool",
            "High-end security system",
        ],
        bathroom: 5,
        bedroom: 5,
        toilet: 6,
        totalViews: 2500,
        bookMarks: 500,
        addedDate: "2025-01-20",
        lastUpdated: "2025-02-18",
        availableUnits: 1,
        utilities: ["Electricity", "Water", "Security"],
    },
    {
        id: 6,
        images: [
            "/images/new-img-3.webp",
            "https://source.unsplash.com/600x400/?cityview",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "Semi-Detached 5-Bedroom Duplex With BQ",
        address: "1001 Allen Avenue, Badagry, Lagos",
        category: "residential",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 500,
        price: 140000000,
        priceType: "Agency Fee",
        quote: "askingPrice",
        quotePrice: 7000000,
        type: "sale",
        reviews: ["Breathtaking view!", "Modern and stylish interior."],
        serviceCharge: 700,
        inspectionFee: 300,
        refundableCautionFee: 8000,
        nonRefundableLegalFees: 300,
        otherFee: 1500,
        propertyBrief: [
            "Floor-to-ceiling glass windows",
            "Private rooftop lounge",
            "24/7 concierge service",
        ],
        bathroom: 4,
        bedroom: 4,
        toilet: 5,
        totalViews: 1800,
        bookMarks: 350,
        addedDate: "2025-02-10",
        lastUpdated: "2025-02-19",
        availableUnits: 1,
        utilities: ["Electricity", "Water", "WiFi", "Security"],
    },
    {
        id: 7,
        images: [
            "/images/sale-3.webp",
            "https://source.unsplash.com/600x400/?conference-room",
        ],
        currency: "naira",
        title: "4-Bedroom Terrace Duplex",
        address: "25 Arokoyo Estate, Mokola, Ibadan",
        category: "commercial",
        coordinate: [6.4913408, 3.391488],
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 350,
        price: 95000000,
        beforePrice: 105000000,
        discount: "30%",
        priceType: "netPrice",
        quote: "firstDeposit",
        quotePrice: 4750000,
        type: "sale",
        reviews: ["Great for corporate headquarters!", "Great location for startups!", "Modern facilities."],
        serviceCharge: 1500,
        inspectionFee: 500,
        refundableCautionFee: 20000,
        nonRefundableLegalFees: 300,
        otherFee: 5000,
        propertyBrief: [
            "State-of-the-art office facilities",
            "Close to public transportation",
            "High-speed internet and meeting rooms",
        ],
        totalViews: 3000,
        bookMarks: 600,
        addedDate: "2025-01-15",
        lastUpdated: "2025-02-17",
        availableUnits: 1,
        utilities: ["Electricity", "Water", "Security", "Internet"],
    },
    {
        id: 8,
        images: [
            "/images/sale-4.webp",
            "https://source.unsplash.com/600x400/?industrial",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "4-Bedroom Terrace Duplex With 2-Bedroom BQ",
        address: "789 Logistics Park, Gwarimpa, Abuja",
        category: "commercial",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 400,
        price: 730000000,
        priceType: "noAdditionalFee",
        quote: "Net Price",
        beforePrice: 105000000,
        discount: "30%",
        quotePrice: 700000,
        type: "sale",
        reviews: ["Perfect for manufacturing!", "Great location for startups!", "Spacious and well-lit.", "Spacious and secure."],
        serviceCharge: 2000,
        inspectionFee: 700,
        refundableCautionFee: 15000,
        nonRefundableLegalFees: 300,
        otherFee: 3000,
        propertyBrief: [
            "Large open space for industrial use",
            "Easy access to highways",
            "Advanced security systems",
        ],
        totalViews: 1500,
        bookMarks: 250,
        addedDate: "2025-02-05",
        lastUpdated: "2025-02-18",
        availableUnits: 1,
        utilities: ["Electricity", "Security", "Water"],
    },
    {
        id: 44,
        images: [
            "/images/sale-1.webp",
            "https://source.unsplash.com/600x400/?industrial",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "4-Bedroom Terrace Duplex",
        address: "789 Logistics Park, Akobo, Ilorin",
        category: "commercial",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 350,
        price: 73400000,
        priceType: "Per Plot / Asking Price",
        quote: "Agency Fee",
        quotePrice: 70000,
        type: "sale",
        reviews: ["Perfect for manufacturing!", "Great location for startups!", "Spacious and well-lit.", "Spacious and secure."],
        serviceCharge: 2000,
        inspectionFee: 700,
        refundableCautionFee: 15000,
        nonRefundableLegalFees: 300,
        otherFee: 3000,
        propertyBrief: [
            "Large open space for industrial use",
            "Easy access to highways",
            "Advanced security systems",
        ],
        totalViews: 1500,
        bookMarks: 250,
        addedDate: "2025-02-05",
        lastUpdated: "2025-02-18",
        availableUnits: 1,
        utilities: ["Electricity", "Security", "Water"],
    },
    {
        id: 38,
        images: [
            "/images/sale-2.webp",
            "https://source.unsplash.com/600x400/?industrial",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "4-Bedroom Terrace Duplex",
        address: "789 Logistics Park, Akobo, Ilorin",
        category: "commercial",
        size: 350,
        price: 73000000,
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        beforePrice: 2000000,
        strike: true,
        priceType: "Asking Price",
        quote: "Agency Fee",
        quotePrice: 70000,
        type: "sale",
        reviews: ["Perfect for manufacturing!", "Great location for startups!", "Spacious and well-lit.", "Spacious and secure."],
        serviceCharge: 2000,
        inspectionFee: 700,
        refundableCautionFee: 15000,
        nonRefundableLegalFees: 300,
        otherFee: 3000,
        propertyBrief: [
            "Large open space for industrial use",
            "Easy access to highways",
            "Advanced security systems",
        ],
        totalViews: 1500,
        bookMarks: 250,
        addedDate: "2025-02-05",
        lastUpdated: "2025-02-18",
        availableUnits: 1,
        utilities: ["Electricity", "Security", "Water"],
    }, {
        id: 39,
        images: [
            "/images/sale-3.webp",
            "https://source.unsplash.com/600x400/?industrial",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "4-Bedroom Condo ",
        address: "789 Logistics Park, Magodo, Lagos",
        category: "commercial",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 350,
        price: 34000000,
        priceType: "Asking Price",
        quote: "Agency Fee",
        quotePrice: 70000,
        type: "sale",
        reviews: ["Perfect for manufacturing!", "Great location for startups!", "Spacious and well-lit.", "Spacious and secure."],
        serviceCharge: 2000,
        inspectionFee: 700,
        refundableCautionFee: 15000,
        nonRefundableLegalFees: 300,
        otherFee: 3000,
        propertyBrief: [
            "Large open space for industrial use",
            "Easy access to highways",
            "Advanced security systems",
        ],
        totalViews: 1500,
        bookMarks: 250,
        addedDate: "2025-02-05",
        lastUpdated: "2025-02-18",
        availableUnits: 1,
        utilities: ["Electricity", "Security", "Water"],
    },

    {
        id: 9,
        images: [
            "/images/shortlet-1.webp",
            "https://source.unsplash.com/600x400/?living-room",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "Luxury 2-Bedroom Apartment with Ocean View",
        address: "22 Ebeano Road, Abakaliki, Ebonyi",
        category: "residential",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        size: 1800,
        price: 110000,
        priceType: "firstPayment",
        quote: "perNight",
        quotePrice: 95000,
        type: "short let",
        reviews: [
            "Amazing ocean view!",
            "Great for vacation stays.",
            "The interior is breathtaking!",
        ],
        serviceCharge: 50,
        inspectionFee: 20,
        refundableCautionFee: 200,
        nonRefundableLegalFees: 300,
        otherFee: 30,
        propertyBrief: [
            "Fully furnished with modern decor",
            "Infinity pool and gym access",
            "Fast WiFi and smart home system",
        ],
        bathroom: 2,
        bedroom: 2,
        toilet: 3,
        totalViews: 1200,
        bookMarks: 400,
        addedDate: "2025-02-10",
        lastUpdated: "2025-02-18",
        availableUnits: 3,
        utilities: ["Electricity", "WiFi", "Security", "Water"],
    },
    {
        id: 10,
        images: [
            "/images/shortlet-2.webp",
            "https://source.unsplash.com/600x400/?swimming-pool",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "5-Bedroom Duplex",
        address: "23 Shehu Road, Gamboru, Borno",
        category: "residential",
        size: 500,
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        price: 90000,
        priceType: "firstPayment",
        quote: "perNight",
        quotePrice: 75000,
        type: "short let",
        reviews: ["Best vacation spot!", "Great location for startups!", "Spacious and well-lit.", "The private pool is amazing!"],
        serviceCharge: 100,
        inspectionFee: 50,
        refundableCautionFee: 500,
        nonRefundableLegalFees: 300,
        otherFee: 75,
        propertyBrief: [
            "Private beach access",
            "Luxury furnishing and entertainment systems",
            "Chef’s kitchen and barbecue area",
        ],
        bathroom: 4,
        bedroom: 4,
        toilet: 5,
        totalViews: 2500,
        bookMarks: 650,
        addedDate: "2025-02-05",
        lastUpdated: "2025-02-19",
        availableUnits: 2,
        utilities: ["Electricity", "WiFi", "Security", "Water"],
    },
    {
        id: 11,
        images: [
            "/images/shortlet-3.webp",
            "https://source.unsplash.com/600x400/?cityview",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "2-Bedroom 4-Flat Apartment",
        propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
        address: "12 Kajola Road, Bodija, Ibadan",
        category: "residential",
        size: 500,
        price: 210000,
        priceType: "firstPayment",
        quote: "perNight",
        quotePrice: 180000,
        type: "short let",
        reviews: ["Perfect for business trips!"],
        serviceCharge: 70,
        inspectionFee: 30,
        refundableCautionFee: 300,
        nonRefundableLegalFees: 300,
        otherFee: 50,
        propertyBrief: [
            "High-rise penthouse with floor-to-ceiling windows",
            "Rooftop lounge and bar access",
            "Fast WiFi and workspace area",
        ],
        bathroom: 3,
        bedroom: 3,
        toilet: 3,
        totalViews: 1800,
        bookMarks: 500,
        addedDate: "2025-02-08",
        lastUpdated: "2025-02-18",
        availableUnits: 2,
        utilities: ["Electricity", "WiFi", "Security", "Water"],
    },
    {
        id: 12,
        images: [
            "/images/new-img-1.webp",
            "https://source.unsplash.com/600x400/?nature",
        ],
        coordinate: [6.4913408, 3.391488],
        currency: "naira",
        title: "5-Bedroom Detached Duplex With BQ",
        address: "7 Pwajok Street, Biu, Adamawa",
        category: "residential",
        size: 1500,
        price: 180000,
        priceType: "firstPayment",
        quote: "perNight",
        quotePrice: 150000,
        type: "short let",
        reviews: ["Beautiful scenery!", "Great location for startups!", "Spacious and well-lit.", "Great getaway from the city."],
        serviceCharge: 40,
        inspectionFee: 15,
        refundableCautionFee: 150,
        nonRefundableLegalFees: 300,
        otherFee: 25,
        propertyBrief: [
            "Secluded location with stunning mountain views",
            "Fireplace and cozy wooden interiors",
            "Hiking and skiing nearby",
        ],
        bathroom: 2,
        bedroom: 2,
        toilet: 2,
        totalViews: 900,
        bookMarks: 300,
        addedDate: "2025-02-06",
        lastUpdated: "2025-02-17",
        availableUnits: 1,
        utilities: ["Electricity", "WiFi", "Water"],
    },



]

export const mockProperties: MockPropertyType = {
    forRent: [
        {
            id: 1,
            images: [
                "/images/new-img-4.webp",
                "/images/sample-1.webp", "/images/sample-2.webp",
                "/images/sample-3.webp",
                "/images/sample-4.webp",
                "/images/sample-5.webp",

            ],
            management_fee: "2000",

            currency: "naira",
            title: "Luxury 3-Bedroom Detached Bungalow ",
            address: "123 Main Street, Akoka, Lagos",
            category: "residential",
            size: 950,
            price: 4700000,
            coordinate: [6.4913408, 3.391488],
            videoLink: "https://www.youtube.com/watch?v=m3E72ZJ54_k",
            staff: members[0],
            priceType: "totalPackage",
            quote: "annum",
            quotePrice: 3500000,
            type: "rent",
            reviews: ["Great location!", "Spacious and modern."],
            serviceCharge: 200,
            inspectionFee: 500,
            refundableCautionFee: 500,
            nonRefundableLegalFees: 300,
            propertyId: 23,
            priceCondition: "Asking Price",
            otherFee: 150,
            renew_fee_period: "500",
            renew_fee_amount: "500",
            renew_service_charge: "500",
            renew_other_charge: "500",
            renew_total_package: "500",
            propertyDesc: `
  <p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest. Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, a fully equipped kitchen with top-quality finishes, and a large living area ideal for family and entertaining.</p>
  <p>The home features state-of-the-art amenities, ample parking space, and a private garden, making it perfect for comfortable living. Located in a prime residential area, it offers easy access to essential services, schools, and shopping centers.</p>
  <p>Ideal for families seeking luxury, privacy, and convenience!</p>
`,
            propertyBrief: [
                "Modern design with open floor plan",
                "Close to shopping centers",
                "Secure building with 24/7 security",
            ],
            bathroom: 2,
            staffListing: propertiesData,
            unitPreference: "None",
            facilities: utilities.map((item) => item.name),
            unitSubtype: "Training Room",
            bedroom: 2,
            toilet: 2,
            totalViews: 1200,
            bookMarks: 300,
            addedDate: "2025-02-15",
            lastUpdated: "2025-02-20",
            availableUnits: 5,
            utilities: ["Water", "Electricity", "WiFi"],
        },
        {
            id: 2,
            images: [
                "/images/new-img-5.webp",
                "https://source.unsplash.com/600x400/?pool",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "Spacious 4-Bedroom Detached Duplex ",
            address: "456 Sunset Blvd, Maitama, Abuja",
            category: "residential",
            size: 700,
            price: 1200000,
            priceType: "totalPackage",
            quote: "month",
            quotePrice: 950000,
            type: "rent",
            reviews: ["Perfect for families!", "Great location!", "Amazing pool and garden."],
            serviceCharge: 400,
            refundableCautionFee: 1200,
            propertyId: 23,
            priceCondition: "Asking Price",
            nonRefundableLegalFees: 500,
            otherFee: 250,
            propertyBrief: [
                "Private swimming pool",
                "Spacious backyard",
                "Gated community with security",
            ],
            bathroom: 4,
            bedroom: 4,
            toilet: 5,
            totalViews: 900,
            bookMarks: 150,
            addedDate: "2025-01-30",
            lastUpdated: "2025-02-18",
            availableUnits: 2,
            utilities: ["Water", "Electricity", "WiFi", "Security"],
        },
        {
            id: 3,
            images: [
                "/images/proxy.webp",
                "https://source.unsplash.com/600x400/?workspace",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "6 Bedroom Semi-Detached Duplex",
            address: "789 Corporate Plaza, Kolapo Ishola GRA, Ibadan",
            category: "commercial",
            size: 1200,
            price: 700000,
            priceType: "totalPackage",
            quote: "week",
            quotePrice: 500000,
            type: "rent",
            reviews: ["Great location for startups!", "Spacious and well-lit.", "Great location for startups!", "Spacious and well-lit."],
            serviceCharge: 600,
            inspectionFee: 100,
            propertyId: 23,
            priceCondition: "Asking Price",
            refundableCautionFee: 2000,
            nonRefundableLegalFees: 1000,
            otherFee: 300,
            propertyBrief: [
                "Fully furnished office space",
                "Close to public transport",
                "High-speed internet included",
            ],
            bathroom: 2,
            totalViews: 500,
            bookMarks: 80,
            addedDate: "2025-02-01",
            lastUpdated: "2025-02-21",
            availableUnits: 3,
            utilities: ["Electricity", "Internet", "Water", "Security"],
        },
        {
            id: 4,
            images: [
                "/images/rent-4.webp",
                "https://source.unsplash.com/600x400/?rooftop",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "3 Bedroom Terrace Duplex",
            address: "321 Creative Ave, Trans Amadi, Rivers",
            category: "residential",
            size: 350,
            price: 6370000,
            priceType: "totalPackage",
            quote: "annum",
            quotePrice: 5500000,
            type: "rent",
            reviews: ["Perfect for artists!", "Cozy and stylish.", "Great location for startups!", "Spacious and well-lit.", "Great location for startups!", "Spacious and well-lit."],
            serviceCharge: 100,
            refundableCautionFee: 300,
            propertyId: 23,
            priceCondition: "Asking Price",
            nonRefundableLegalFees: 200,
            otherFee: 100,
            propertyBrief: [
                "Open floor plan with industrial design",
                "Pet-friendly apartment",
                "Close to cafes and art galleries",
            ],
            bathroom: 1,
            bedroom: 1,
            toilet: 1,
            totalViews: 700,
            bookMarks: 200,
            addedDate: "2025-02-10",
            lastUpdated: "2025-02-22",
            availableUnits: 4,
            utilities: ["WiFi", "Water", "Electricity"],
        },
    ],
    forSale: [
        {
            id: 5,
            images: [
                "/images/new-img-2.webp",
                "https://source.unsplash.com/600x400/?backyard",
            ],
            coordinate: [6.4913408, 3.391488],
            title: "Luxury 5-Bedroom Duplex With 2-Bedroom BQ",
            address: "456 Beverly Hills, Apete, Ibadan",
            category: "residential",
            currency: "naira",
            beforePrice: 2000000,
            discount: "30%",
            size: 600,
            price: 55000000,
            priceType: "askingPrice",
            quote: "firstDeposit",
            quotePrice: 2750000,
            type: "sale",
            reviews: ["State-of-the-art home automation!", "Excellent location."],
            serviceCharge: 500,
            inspectionFee: 200,
            refundableCautionFee: 5000,
            nonRefundableLegalFees: 300,
            otherFee: 1000,
            propertyBrief: [
                "Integrated smart home technology",
                "Expansive backyard with pool",
                "High-end security system",
            ],
            bathroom: 5,
            bedroom: 5,
            toilet: 6,
            totalViews: 2500,
            bookMarks: 500,
            addedDate: "2025-01-20",
            lastUpdated: "2025-02-18",
            availableUnits: 1,
            utilities: ["Electricity", "Water", "Security"],
        },
        {
            id: 6,
            images: [
                "/images/new-img-3.webp",
                "https://source.unsplash.com/600x400/?cityview",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "Semi-Detached 5-Bedroom Duplex With BQ",
            address: "1001 Allen Avenue, Badagry, Lagos",
            category: "residential",
            size: 500,
            price: 140000000,
            priceType: "askingPrice",
            quote: "initialPrice",
            quotePrice: 7000000,
            type: "sale",
            reviews: ["Breathtaking view!", "Modern and stylish interior."],
            serviceCharge: 700,
            inspectionFee: 300,
            refundableCautionFee: 8000,
            nonRefundableLegalFees: 300,
            otherFee: 1500,
            propertyBrief: [
                "Floor-to-ceiling glass windows",
                "Private rooftop lounge",
                "24/7 concierge service",
            ],
            bathroom: 4,
            bedroom: 4,
            toilet: 5,
            totalViews: 1800,
            bookMarks: 350,
            addedDate: "2025-02-10",
            lastUpdated: "2025-02-19",
            availableUnits: 1,
            utilities: ["Electricity", "Water", "WiFi", "Security"],
        },
        {
            id: 7,
            images: [
                "/images/sale-3.webp",
                "https://source.unsplash.com/600x400/?conference-room",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "4-Bedroom Terrace Duplex",
            address: "25 Arokoyo Estate, Mokola, Ibadan",
            category: "commercial",
            size: 350,
            price: 95000000,
            beforePrice: 105000000,
            discount: "30%",
            priceType: "netPrice",
            quote: "initialPrice",
            quotePrice: 4750000,
            type: "sale",
            reviews: ["Great for corporate headquarters!", "Great location for startups!", "Modern facilities."],
            serviceCharge: 1500,
            inspectionFee: 500,
            refundableCautionFee: 20000,
            nonRefundableLegalFees: 300,
            otherFee: 5000,
            propertyBrief: [
                "State-of-the-art office facilities",
                "Close to public transportation",
                "High-speed internet and meeting rooms",
            ],
            totalViews: 3000,
            bookMarks: 600,
            addedDate: "2025-01-15",
            lastUpdated: "2025-02-17",
            availableUnits: 1,
            utilities: ["Electricity", "Water", "Security", "Internet"],
        },
        {
            id: 8,
            images: [
                "/images/sale-4.webp",
                "https://source.unsplash.com/600x400/?industrial",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "4-Bedroom Terrace Duplex With 2-Bedroom BQ",
            address: "789 Logistics Park, Gwarimpa, Abuja",
            category: "commercial",
            size: 400,
            price: 730000000,
            priceType: "noAdditionalFee",
            quote: "Net Price",
            quotePrice: 700000,
            type: "sale",
            reviews: ["Perfect for manufacturing!", "Great location for startups!", "Spacious and well-lit.", "Spacious and secure."],
            serviceCharge: 2000,
            inspectionFee: 700,
            refundableCautionFee: 15000,
            nonRefundableLegalFees: 300,
            otherFee: 3000,
            propertyBrief: [
                "Large open space for industrial use",
                "Easy access to highways",
                "Advanced security systems",
            ],
            totalViews: 1500,
            bookMarks: 250,
            addedDate: "2025-02-05",
            lastUpdated: "2025-02-18",
            availableUnits: 1,
            utilities: ["Electricity", "Security", "Water"],
        },
    ],
    forShortlet: [
        {
            id: 9,
            images: [
                "/images/shortlet-1.webp",
                "https://source.unsplash.com/600x400/?living-room",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "Luxury 2-Bedroom Apartment with Ocean View",
            address: "22 Ebeano Road, Abakaliki, Ebonyi",
            category: "residential",
            size: 1800,
            price: 110000,
            priceType: "firstPayment",
            quote: "perNight",
            quotePrice: 95000,
            type: "short let",
            reviews: [
                "Amazing ocean view!",
                "Great for vacation stays.",
                "The interior is breathtaking!",
            ],
            serviceCharge: 50,
            inspectionFee: 20,
            refundableCautionFee: 200,
            nonRefundableLegalFees: 300,
            otherFee: 30,
            propertyBrief: [
                "Fully furnished with modern decor",
                "Infinity pool and gym access",
                "Fast WiFi and smart home system",
            ],
            bathroom: 2,
            bedroom: 2,
            toilet: 3,
            totalViews: 1200,
            bookMarks: 400,
            addedDate: "2025-02-10",
            lastUpdated: "2025-02-18",
            availableUnits: 3,
            utilities: ["Electricity", "WiFi", "Security", "Water"],
        },
        {
            id: 10,
            images: [
                "/images/shortlet-2.webp",
                "https://source.unsplash.com/600x400/?swimming-pool",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "5-Bedroom Duplex",
            address: "23 Shehu Road, Gamboru, Borno",
            category: "residential",
            size: 500,
            price: 90000,
            priceType: "firstPayment",
            quote: "perNight",
            quotePrice: 75000,
            type: "short let",
            reviews: ["Best vacation spot!", "Great location for startups!", "Spacious and well-lit.", "The private pool is amazing!"],
            serviceCharge: 100,
            inspectionFee: 50,
            refundableCautionFee: 500,
            nonRefundableLegalFees: 300,
            otherFee: 75,
            propertyBrief: [
                "Private beach access",
                "Luxury furnishing and entertainment systems",
                "Chef’s kitchen and barbecue area",
            ],
            bathroom: 4,
            bedroom: 4,
            toilet: 5,
            totalViews: 2500,
            bookMarks: 650,
            addedDate: "2025-02-05",
            lastUpdated: "2025-02-19",
            availableUnits: 2,
            utilities: ["Electricity", "WiFi", "Security", "Water"],
        },
        {
            id: 11,
            images: [
                "/images/shortlet-3.webp",
                "https://source.unsplash.com/600x400/?cityview",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "2-Bedroom 4-Flat Apartment",
            address: "12 Kajola Road, Bodija, Ibadan",
            category: "residential",
            size: 500,
            price: 210000,
            priceType: "firstPayment",
            quote: "perNight",
            quotePrice: 180000,
            type: "short let",
            reviews: ["Perfect for business trips!"],
            serviceCharge: 70,
            inspectionFee: 30,
            refundableCautionFee: 300,
            nonRefundableLegalFees: 300,
            otherFee: 50,
            propertyBrief: [
                "High-rise penthouse with floor-to-ceiling windows",
                "Rooftop lounge and bar access",
                "Fast WiFi and workspace area",
            ],
            bathroom: 3,
            bedroom: 3,
            toilet: 3,
            totalViews: 1800,
            bookMarks: 500,
            addedDate: "2025-02-08",
            lastUpdated: "2025-02-18",
            availableUnits: 2,
            utilities: ["Electricity", "WiFi", "Security", "Water"],
        },
        {
            id: 12,
            images: [
                "/images/new-img-1.webp",
                "https://source.unsplash.com/600x400/?nature",
            ],
            coordinate: [6.4913408, 3.391488],
            currency: "naira",
            title: "5-Bedroom Detached Duplex With BQ",
            address: "7 Pwajok Street, Biu, Adamawa",
            category: "residential",
            size: 1500,
            price: 180000,
            priceType: "firstPayment",
            quote: "perNight",
            quotePrice: 150000,
            type: "short let",
            reviews: ["Beautiful scenery!", "Great location for startups!", "Spacious and well-lit.", "Great getaway from the city."],
            serviceCharge: 40,
            inspectionFee: 15,
            refundableCautionFee: 150,
            nonRefundableLegalFees: 300,
            otherFee: 25,
            propertyBrief: [
                "Secluded location with stunning mountain views",
                "Fireplace and cozy wooden interiors",
                "Hiking and skiing nearby",
            ],
            bathroom: 2,
            bedroom: 2,
            toilet: 2,
            totalViews: 900,
            bookMarks: 300,
            addedDate: "2025-02-06",
            lastUpdated: "2025-02-17",
            availableUnits: 1,
            utilities: ["Electricity", "WiFi", "Water"],
        },
    ]
}




// const properties: PropertyType[] = [
//     // Example property data goes here
// ];

export function findPropertyById(id: number): PropertyType {
    return propertiesData.find(property => property.id === id) as PropertyType;
}

export function findPropertiesByType(type: "sale" | "rent" | "short let"): PropertyType[] {
    return propertiesData.filter(property => property.type === type);
}

export function findPropertiesByTypeOptional(
    type?: "sale" | "rent" | "short let"
): PropertyType[] {
    if (type) {
        return propertiesData.filter(property => property.type === type);
    }
    return propertiesData; // If no type is provided, return all properties
}






